import { get, isNil } from "lodash";
import { useTranslation } from "react-i18next";
import { FAN_COIL_FAN_TYPES } from "../../constants";
import { Device } from "../../models/device.model";
import { FanCoilFanSpeed, FanCoilFanType } from "../../types";

export interface FanSpeedLabelProps {
    actualFanSpeed: FanCoilFanSpeed | null;
    fanType: FanCoilFanType | null;
}

export const useFanSpeed = () => {
    const { t } = useTranslation(["devices", "common"]);

    const getActualFanSpeed = (device: Device) =>
        get(device, "status.fanCoil.actualFanSpeed", null);

    const getActualFanType = (device: Device) =>
        get(device, "settings.fanCoil.fanCoilType.fanType", null);

    const getFanSpeedLabel = (
        props: FanSpeedLabelProps | undefined | null = null
    ) => {
        if (isNil(props)) {
            return t("common:off");
        }
        const { actualFanSpeed, fanType } = props;

        if (isNil(fanType) || isNil(actualFanSpeed)) {
            return;
        }

        if (actualFanSpeed === 0) {
            return t("common:off");
        }

        if (actualFanSpeed === -1) {
            return t("fanSpeed.auto");
        }

        if (fanType === FAN_COIL_FAN_TYPES.SPEED_3) {
            const speedMapping: Record<number, string> = {
                1: t("fanSpeed.low"),
                2: t("fanSpeed.low"),
                3: t("fanSpeed.medium"),
                4: t("fanSpeed.medium"),
                5: t("fanSpeed.high"),
                6: t("fanSpeed.high"),
            };

            return speedMapping[actualFanSpeed] || undefined;
        } else if (fanType === FAN_COIL_FAN_TYPES.ECM) {
            return actualFanSpeed;
        }
    };

    return { getFanSpeedLabel, getActualFanSpeed, getActualFanType };
};
